import withAuth from './with-auth'
import Mutation from './mutation'

export default withAuth(Mutation)
